import { render, staticRenderFns } from "./VerdictsCard.vue?vue&type=template&id=810a5d1e"
import script from "./VerdictsCard.vue?vue&type=script&lang=js"
export * from "./VerdictsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports